// extracted by mini-css-extract-plugin
export default {"creatingText":"my-courses_creatingText__rId4c","createCourseButton":"my-courses_createCourseButton__+PMAL"};